<template>
  <div>
    <b-row>
      <b-col>
        <div class="card my-0 py-0 border border-primary">
          <div class="card-header bg-transparent border-primary py-0">
            <h5 class="my-0 text-primary">
              <i :class="`fas fa-ticket-alt me-3`"></i>
              {{ $t('Total') }}
            </h5>
          </div>
          <div class="card-body row">
            <div class="summary-column">
              <span class="text-muted small d-block">
                {{ $t('Users') }}
              </span>
              <span class="h5">{{ payment.summary.active_customers_count }}</span>
            </div>

            <div class="summary-column">
              <span class="text-muted small d-block">
                {{ $t('Comissão') }}
              </span>
              <span class="h5">{{ $utils.formatMoneyFloat(payment.summary.reward_accumulative) }}</span>
            </div>

            <div class="summary-column" v-if="!hideCpa">
              <span class="text-muted small d-block"> CPA </span>
              <span class="h5">{{ $utils.formatMoneyFloat(payment.summary.reward_mark) }}</span>
            </div>

            <div class="summary-column">
              <span class="text-muted small d-block">
                {{ $t('Valor a Pagar') }}
              </span>
              <span class="h5">{{ $utils.formatMoneyFloat(payment.summary.reward_total) }}</span>
            </div>

            <template v-if="payment.carryNegativeGgrEnabled">
              <div class="summary-column">
                <span class="text-muted small d-block">{{ $t('GGR') }}</span>
                <span class="h5">{{ $utils.formatMoneyFloat(payment.summary.current_ggr) }}</span>
              </div>
              <div class="summary-column">
                <span class="text-muted small d-block">{{ $t('Previous month GGR') }}</span>
                <span class="h5">{{ $utils.formatMoneyFloat(payment.summary.previous_period_ggr) }}</span>
              </div>
              <div class="summary-column">
                <span class="text-muted small d-block">{{ $t('GGR balance for next month') }}</span>
                <span :class="['h5', { 'text-danger': payment.summary.net_ggr_balance < 0 }]">{{
                  $utils.formatMoneyFloat(payment.summary.net_ggr_balance)
                }}</span>
              </div>
              <div class="summary-column">
                <span class="text-muted small d-block">{{ $t('Commission GGR base') }}</span>
                <span class="h5">{{ $utils.formatMoneyFloat(payment.summary.commission_ggr_base) }}</span>
              </div>
              <div class="summary-column">
                <span class="text-muted small d-block">{{ $t('Taxa Admin.') }}</span>
                <span class="h5">{{ $utils.formatMoneyFloat(payment.summary.admin_fee) }}</span>
              </div>
              <div class="summary-column">
                <span class="text-muted small d-block">{{ $t('Líquido') }}</span>
                <span class="h5">{{ $utils.formatMoneyFloat(payment.summary.net) }}</span>
              </div>
              <div class="summary-column">
                <span class="text-muted small d-block">{{ $t('Balance for next month') }}</span>
                <span :class="['h5', { 'text-danger': payment.summary.closing_ggr_balance < 0 }]">{{
                  $utils.formatMoneyFloat(payment.summary.closing_ggr_balance)
                }}</span>
              </div>
            </template>
          </div>
        </div>
      </b-col>
    </b-row>
    <b-row class="mt-2">
      <b-col class="text-center cursor-pointer" @click="show_details = !show_details">
        {{ $t('Show Details') }}
      </b-col>
    </b-row>
    <div v-if="show_details" class="list-group">
      <b-row class="list-group-item" v-for="(affiliate, i) in payment.data" :key="i">
        <b-col class="">
          <b-row>
            <b-col md="4">
              <b>{{ $t('Nome') }}:</b>&nbsp;{{ affiliate.name }}
            </b-col>
            <b-col md="4">
              <b class="uppercase-text">{{ getDocumentType(affiliate) }}:</b>
              <span class="-nowrap">&nbsp; {{ getDocument(affiliate) }}</span>
            </b-col>
            <b-col md="4" v-if="!payment.carryNegativeGgrEnabled">
              <b>{{ $t('Valor a Pagar') }}:</b>
              <span class="-nowrap">&nbsp;{{ $utils.formatMoneyFloat(affiliate.reward_total) }}</span>
            </b-col>
            <template v-else>
              <b-col md="4">
                <b>{{ $t('GGR') }}:</b>
                <span class="-nowrap">&nbsp;{{ $utils.formatMoneyFloat(affiliate.current_ggr) }}</span>
              </b-col>
              <b-col md="4">
                <b>{{ $t('Previous month GGR') }}:</b>
                <span class="-nowrap">&nbsp;{{ $utils.formatMoneyFloat(affiliate.previous_period_ggr) }}</span>
              </b-col>
              <b-col md="4">
                <b>{{ $t('GGR balance for next month') }}:</b>
                <span :class="['-nowrap', { 'text-danger': affiliate.net_ggr_balance < 0 }]"
                  >&nbsp;{{ $utils.formatMoneyFloat(affiliate.net_ggr_balance) }}</span
                >
              </b-col>
              <b-col md="4">
                <b>{{ $t('Commission GGR base') }}:</b>
                <span class="-nowrap">&nbsp;{{ $utils.formatMoneyFloat(affiliate.commission_ggr_base) }}</span>
              </b-col>
              <b-col md="4">
                <b>{{ $t('Taxa Admin.') }}:</b>
                <span class="-nowrap">&nbsp;{{ $utils.formatMoneyFloat(affiliate.admin_fee) }}</span>
              </b-col>
              <b-col md="4">
                <b>{{ $t('Líquido') }}:</b>
                <span class="-nowrap">&nbsp;{{ $utils.formatMoneyFloat(affiliate.net) }}</span>
              </b-col>
              <b-col md="4">
                <b>{{ $t('Comissão') }}:</b>
                <span class="-nowrap">&nbsp;{{ $utils.formatMoneyFloat(affiliate.reward_accumulative) }}</span>
              </b-col>
              <b-col md="4">
                <b>{{ $t('Valor a Pagar') }}:</b>
                <span class="-nowrap">&nbsp;{{ $utils.formatMoneyFloat(affiliate.reward_total) }}</span>
              </b-col>
              <b-col md="4">
                <b>{{ $t('Balance for next month') }}:</b>
                <span :class="['-nowrap', { 'text-danger': affiliate.closing_ggr_balance < 0 }]"
                  >&nbsp;{{ $utils.formatMoneyFloat(affiliate.closing_ggr_balance) }}</span
                >
              </b-col>
            </template>
          </b-row>
        </b-col>
      </b-row>
    </div>
    <hr />
    <div class="row">
      <div class="col-md-6">
        <button :disabled="$store.state.isLoading" class="btn btn-secondary w-100" @click="$emit('hide')">
          {{ $t('Back') }}
        </button>
      </div>
      <div class="col-md-6">
        <button :disabled="$store.state.isLoading" class="btn btn-primary w-100" @click="$emit('confirm')">
          {{ payment.carryNegativeGgrEnabled ? $t('Confirm closing') : $t('Confirmar') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    payment: {
      type: Object
    }
  },
  emits: ['hide', 'confirm'],
  data() {
    return {
      show_details: false
    };
  },
  computed: {
    hideCpa() {
      this.$store.state.companySettings;
      return this.shouldHideCpa();
    },
    paymentTotal() {
      return this.paymentResume?.total || {};
    },
    paymentData() {
      return this.paymentResume?.dataset || [];
    }
  },
  methods: {
    getDocument(affiliate) {
      return affiliate?.settings?.paymentInfo?.meta?.key || '';
    },
    getDocumentType(affiliate) {
      return affiliate?.settings?.paymentInfo?.meta?.type || '';
    }
  }
};
</script>

<style scoped>
.uppercase-text {
  text-transform: uppercase;
}
</style>
